<template>
  <div class="mobileBox">
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/homeBanner_m.png"/>


      <top-nav></top-nav>


      <div class="homeBannerText animated" :class="animates.mm6 ? 'fadeInUp' : 'hideBox'">
        <div class="logoBox"><img src="../../../assets/icon/Banner Main@2x.png"/></div>
        <div class="text1">扩大你的业务范围和支付.</div>
        <div class="bannerText3" style="overflow: visible;"  @click="navClick('/apply_m')"><span >申请</span></div>
      </div>
    </div>

    <div class="contentBox">
      <!--板块1-->
      <div class="index01" id="m1">
        <div class="index01_m animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
          <div class="content_left_title">支付解决方案</div>
          <div class="tabsBox">
            <div class="tabsTitle">
              <span :class="act.tabsTitleId===1 ? 'act' : ''" @click="tabsTitleClick(1)">线下支付</span>
              <span :class="act.tabsTitleId===2 ? 'act' : ''" @click="tabsTitleClick(2)">线上支付</span>
            </div>
            <div class="tabsContent">
              <ul v-if="act.tabsTitleId===1">
                <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)">
                  <div v-show="show.shows1===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_instore1.png"/></div>
                    <div class="textDiv">店内二维码</div>
                  </div>
                  <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                    <div class="textTitle">店内二维码</div>
                    <div class="textContent">消费者可以通过扫描店内静态二维码，并输入所购商品金额以进行付款.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)">
                  <div v-show="show.shows2===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_instore2.png"/></div>
                    <div class="textDiv">智能移动收款机</div>
                  </div>
                  <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                    <div class="textTitle">智能移动收款机</div>
                    <div class="textContent">智能移动收款机可以生成动态二维码由消费者扫码支付，或者扫取消费者支付宝/微信支付付款码直接收款.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)">
                  <div v-show="show.shows3===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_instore3.png"/></div>
                    <div class="textDiv">POS零售系统商</div>
                  </div>
                  <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                    <div class="textTitle">POS零售系统商</div>
                    <div class="textContent">我们支持商户将自家使用的POS系统接入SuperiorPay支付，拥有SuperiorPay POS系统的同样功能.</div>
                  </div>
                </li>
                <!--<li class="iconLi">-->
                  <!--<div class="borderDiv">-->
                    <!--<div class="btnDiv"  @click="navClick('/apply_m')">CONTACT US</div>-->
                  <!--</div>-->
                <!--</li>-->
                <li style="clear: both;"></li>
              </ul>
              <ul v-if="act.tabsTitleId===2">
                <li class="iconLi" @mouseenter="enter1(1,1)" @mouseleave="leave1(1,0)">
                  <div v-show="show.shows1===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online1.png"/></div>
                    <div class="textDiv">第三方收银台</div>
                  </div>
                  <div v-show="show.ids1===1 && show.shows1===1" class="borderDiv border">
                    <div class="textTitle">第三方收银台</div>
                    <div class="textContent">用于PC端口，用户在PC端网页跳转支付宝/微信支付第三方收银页面进行支付.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter2(2,1)" @mouseleave="leave2(2,0)">
                  <div v-show="show.shows2===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online2.png"/></div>
                    <div class="textDiv">H5端口</div>
                  </div>
                  <div v-show="show.ids2===2 && show.shows2===1" class="borderDiv border">
                    <div class="textTitle">H5端口</div>
                    <div class="textContent">用于移动设备端口，用户与移动端网页付款，并跳转支付宝/微信支付App内进行支付.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter3(3,1)" @mouseleave="leave3(3,0)">
                  <div  v-show="show.shows3===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online3.png"/></div>
                    <div class="textDiv">SDK端口</div>
                  </div>
                  <div v-show="show.ids3===3 && show.shows3===1" class="borderDiv border">
                    <div class="textTitle">SDK端口</div>
                    <div class="textContent">用于移动设备App端口，用户直接在设备App内进行支付.</div>
                  </div>
                </li>
                <li class="iconLi" @mouseenter="enter4(4,1)" @mouseleave="leave4(4,0)">
                  <div v-show="show.shows4===0" class="borderDiv">
                    <div class="iconDiv"><img src="../../../assets/icon/home_online4.png"/></div>
                    <div class="textDiv">JSAPI端口</div>
                  </div>
                  <div v-show="show.ids4===4 && show.shows4===1" class="borderDiv border">
                    <div class="textTitle">JSAPI端口</div>
                    <div class="textContent">用于移动设备App内小程序端口，用户可以在小程序内直接进行支付.</div>
                  </div>
                </li>
                <li style="clear: both;"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!--板块2-->
      <div class="index02" id="m2">
        <div class="index02_m animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
          <div class="content_center_title">你知道吗？</div>
          <div class="contentBox">
            <div class="text1">中国是澳大利亚最大，最有价值的入境游客市场。在截至2018年9月的一年中，短期中国游客前往该国旅行了130万人次，并向澳大利亚游客经济体提供了115亿澳元。</div>
            <ul class="index02Ul">
              <li class="index02Li leftLi">
                <div class="div80">
                  <div class="title">中国支付生态：</div>
                  <div class="content">根据Ipsos最近的一项调查：第三方移动支付用户研究报告。据统计，中国有超过9.4亿活跃的移动支付用户.</div>
                  <div class="btnDiv">
                    <div class="btn1" @click="linkDownload($baseUrl+'/static/digial_sales_kit.pdf')" >了解更多</div>
                    <div class="btn2" @click="navClick('/apply_m')">申请</div>
                  </div>
                </div>
              </li>
              <li class="index02Li centerLi">
                <div class="div80">
                  <div class="centerText">Share of Transaction<br/>Value<br/>by Payment Method</div>
                </div>
              </li>
              <li class="index02Li rightLi">
                <div class="div80">
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon1.png"/>线下移动支付-41%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon2.png"/>线上移动支付-19%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon3.png"/>线下银行卡支付 -16%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon4.png"/>线上银行卡支付-14%
                  </div>
                  <div class="rowBox">
                    <img src="../../../assets/icon/home_index2_icon5.png"/>其他-16%
                  </div>
                </div>
              </li>
              <li style="clear: both;"></li>
            </ul>
          </div>
        </div>
      </div>

      <!--板块3-->
      <div class="index03" id="m3">
        <div class="index03_m animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
          <div class="content_center_title">WHY SUPERIORPAY</div>
          <div class="contentBox">
            <ul>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon1.png"/></div>
                <div class="textDiv">免费注册无额外费用</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon2.png"/></div>
                <div class="textDiv">无需额外设立支付宝或微信账户</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon3.png"/></div>
                <div class="textDiv">'T+1' 自动清算</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon4.png"/></div>
                <div class="textDiv">商户交易额不受限</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon5.png"/></div>
                <div class="textDiv">澳洲顶级银行资金管理</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon6.png"/></div>
                <div class="textDiv">网页&App账户后台管理</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon7.png"/></div>
                <div class="textDiv">一站式多平台营销，快速引流</div>
              </li>
              <li>
                <div class="iconDiv"><img src="../../../assets/icon/home_index3_icon8.png"/></div>
                <div class="textDiv">24小时在线客服</div>
              </li>
            </ul>

          </div>
          <div style="clear: both"></div>
        </div>
      </div>

      <!--板块4-->
      <div class="index04" id="m4">
        <div class="index04_m animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
          <div class="content_center_title">POS系统对接支持</div>
          <div class="contentBox">SuperiorPay与澳大利亚本地POS系统供应商合作，包括Blueshyft，Futura，AuPos，IPOS，PosPal和GVT，实现系统集成，结算管理，退款管理等，确保客户获得全面的跨境支付服务.</div>
          <div class="btn" @click="navClick('/apply_m')">申请</div>
          <ul class="logoUl">
            <li><img src="../../../assets/icon/home_index4_icon1.png"/></li>
            <li><img src="../../../assets/icon/home_index4_icon2.png"/></li>
            <li><img src="../../../assets/icon/home_index4_icon3.png"/></li>
            <!-- <li><img src="../../../assets/icon/home_index4_icon4.png"/></li> -->
            <li><img src="../../../assets/icon/home_index4_icon5.png"/></li>
            <li><img src="../../../assets/icon/home_index4_icon6.png"/></li>
          </ul>
        </div>
      </div>

      <!--板块5-->
      <div class="index05" id="m5" v-show="false">
        <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">


          <div class="swiper-container">
            <div class="swiper-wrapper index5Ul">
              <div class="swiper-slide index5Li">
                <div class="mapBox"><img src="../../../assets/img/home_map_img1.png"/></div>
                <div class="mapTitle">悉尼办公室</div>
                <div class="mapContent">1753/9 Castlereagh St<br/> Capita Centre <br/>Sydney NSW 2000<!-- <br/> Phone:1300 066 006 --></div>
              </div>
              <div class="swiper-slide index5Li">
                <div class="mapBox"><img src="../../../assets/img/home_map_img2.png"/></div>
                <div class="mapTitle">墨尔本办公室</div>
                <div class="mapContent">201, Level 2B<br/> 818 Whitehorse Rd<br/> Box Hill VIC 3128<!-- <br/> Phone: 1300 066 006 --></div>
              </div>
              <div class="swiper-slide index5Li">
                <div class="mapBox"><img src="../../../assets/img/home_map_img3.png"/></div>
                <div class="mapTitle">阿德莱德办公室</div>
                <div class="mapContent">177 Gilbert street, Adelaide<br/> SA 5000 <!-- <br/>Phone: 1300 066 006 --></div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
            <!-- 如果需要导航按钮 -->
            <!--<div class="swiper-button-prev"></div>-->
            <!--<div class="swiper-button-next"></div>-->
            <!-- 如果需要滚动条 -->
            <!--<div class="swiper-scrollbar"></div>-->
          </div>

        </div>
      </div>

      <!--底部-->
      <div class="footer_m ">
        <div class="footer_mText">
          Supay Technology Pty Ltd. Authorized Representative Number 001283947
          <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import topNav from './nav_m'
  let timer = null; //定义初始值
    export default {
      components:{topNav},
      name: "home_m",
      props:{
        step:{   //此数据是控制动画快慢的
          type:Number,
          default:50
        }
      },
      data(){
          return{
            act:{
              tabsTitleId:1,
            },
            show:{
              ids1:0,
              shows1:0,
              ids2:0,
              shows2:0,
              ids3:0,
              shows3:0,
              ids4:0,
              shows4:0,
            },
            animates:{
              mm1:false,
              mm2:false,
              mm3:false,
              mm4:false,
              mm5:false,
              mm6:false,
            },
          }
      },
      destroyed(){
        window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
      },
      mounted () {
        document.documentElement.scrollTop=0;

        new Swiper('.swiper-container', {
          loop:true,
          autoplay:true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          pagination:{
            el:".swiper-pagination",
            clickable:true,
          },
          // navigation:{
          //   prevEl:".swiper-button-prev",
          //   nextEl:".swiper-button-next",
          // }
        });


        this.animates.mm1 = true;
        this.animates.mm6 = true;
        window.addEventListener('scroll', this.handleScroll)




      },

      methods:{
        //鼠标滑动动画
        handleScroll () {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

          var offsetTop1 = document.querySelector('#m1').offsetTop;
          var offsetTop2 = document.querySelector('#m2').offsetTop;
          var offsetTop3 = document.querySelector('#m3').offsetTop;
          var offsetTop4 = document.querySelector('#m4').offsetTop;
          var offsetTop5 = document.querySelector('#m5').offsetTop;


          if (scrollTop > offsetTop1-800) {
            this.animates.mm1 = true
          } else {
            this.animates.mm1 = false
          }
          if (scrollTop > offsetTop2-800) {
            this.animates.mm2 = true
          } else {
            this.animates.mm2 = false
          }
          if (scrollTop > offsetTop3-800) {
            this.animates.mm3 = true
          } else {
            this.animates.mm3 = false
          }
          if (scrollTop > offsetTop4-800) {
            this.animates.mm4 = true
          } else {
            this.animates.mm4 = false
          }
          if (scrollTop > offsetTop5-800) {
            this.animates.mm5 = true
          } else {
            this.animates.mm5 = false
          }
        },

        //  点击导航
        navClick(url){
          this.$router.push(url);
        },//打开新连接
        linkDownload (url) {
          window.open(url,'_blank') // 新窗口打开外链接
        },
        
        //  tabs切换
        tabsTitleClick(index){
          this.act.tabsTitleId=index;
        },
        //  板块1鼠标移入移出
        enter1(id,show){
          this.show.ids1 = id;
          this.show.shows1 = show;
        },
        leave1(id,show){
          this.show.ids1 = id;
          this.show.shows1 = show;
        },
        enter2(id,show){
          this.show.ids2 = id;
          this.show.shows2 = show;
        },
        leave2(id,show){
          this.show.ids2 = id;
          this.show.shows2 = show;
        },
        enter3(id,show){
          this.show.ids3 = id;
          this.show.shows3 = show;
        },
        leave3(id,show){
          this.show.ids3 = id;
          this.show.shows3 = show;
        },
        enter4(id,show){
          this.show.ids4 = id;
          this.show.shows4 = show;
        },
        leave4(id,show){
          this.show.ids4 = id;
          this.show.shows4 = show;
        },
        //置顶
        toTop(){ // 动画

          timer = setInterval(function () {
            let osTop = document.documentElement.scrollTop || document.body.scrollTop;
            let ispeed = Math.floor(-osTop / 5);
            document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
            // this.isTop = true
            if (osTop === 0) {
              clearInterval(timer)
            }
          },30)

        },

      }



    }
</script>

<style scoped>
  .index05 .swiper-container {
    width: 100%;
    height: auto;
    padding-bottom: 70px;
  }



  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}


  .topBanner .homeBannerText{position: absolute;top: 34%;width: 100%;height: auto;}
  .topBanner .homeBannerText .logoBox{width: 100%;height: 30px;text-align: center;}
  .topBanner .homeBannerText .logoBox>img{width: 7.75rem;height: 1.625rem;}
  .topBanner .homeBannerText .text1{width: 80%;padding: 3rem 10%; font-size: 1rem;color: #fff;text-align: center;height: 22%;font-family: MontserratRegular;}
  .topBanner .homeBannerText .bannerText3{font-size: 17px;color: rgba(255,255,255,0.6);text-align: center;cursor: pointer;margin-top: 5%;}
  .topBanner .homeBannerText .bannerText3>span{width: 95px;height: 35px;line-height: 35px;display: inline-block; border: 1px solid rgba(255,255,255,0.6);font-family: MontserratMedium;}
  .topBanner .homeBannerText .bannerText3>span:hover{color: #fff;border: 1px solid #fff;transition: all 0.5s ease-in-out;}



  .content_left_title{font-size: 1rem;color: #4a4a4a;height: 5rem;line-height: 5rem;width: calc(100% - 30px);font-family:OpenSans600;padding: 0 15px;}
  .content_center_title{font-size: 1.5rem;color: #4a4a4a;height: 5rem;line-height: 5rem;width: 100%;text-align: center;font-family: OpenSans300;font-weight:300;}


  /*板块1*/
  .index01{height: auto;background-color: #fff;padding:2rem 15px;}
  .index01 .tabsBox{width: 100%;height: auto;}
  .index01 .tabsBox .tabsTitle{width: calc(100% - 30px);margin: auto; height: 2rem;line-height: 2rem; border-bottom: 1px solid #dbdbdb;font-family: MontserratMedium;}
  .index01 .tabsBox .tabsTitle>span{font-size: 1rem;color: #4a4a4a;padding:0 0.7rem;display: inline-block;margin-right: 1rem;cursor: pointer;}
  .index01 .tabsBox .tabsTitle>span.act{border-bottom: 2px solid #f05423;}
  .index01 .tabsBox .tabsContent{width: 100%;height: auto;}
  .index01 .tabsBox .tabsContent>ul{width: 100%;height: 100%;margin-top: 5px;}
  .index01 .tabsBox .tabsContent>ul .iconLi{width: calc(50% - 0.35rem);height: 10rem;float: left;cursor: pointer;border: 1px solid rgba(0,0,0,0);margin-top: 15px;
    box-shadow:
      -2px 0 7px -1px #dadada,
      0 -2px 0px -1px rgba(0,0,0,0),
      0 2px 7px -1px #dadada,
      2px 0 7px -1px #dadada;
  }

  .index01 .tabsBox .tabsContent>ul .iconLi:nth-of-type(even){float: right;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv{width: 100%;height: calc(100% - 2px);padding: 1.5rem 0;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border{padding: 0;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .iconDiv{width: 100%;text-align: center;margin-top: 0rem;margin-bottom: 0rem;height: 6rem;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .iconDiv>img{transform: scale(0.7);}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .textDiv{width: 100%;text-align: center;font-size: 0.65rem;color: #4a4a4a;font-family: MontserratMedium;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv .btnDiv{margin:6.5rem auto; color: #fff;font-size: 0.97rem;background-color: #083358;font-family: MontserratMedium;width: 8rem;text-align: center;border-radius: 4px; height: 2.5rem;line-height: 2.5rem;cursor: pointer;}


  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border .textTitle{width: 100%;margin:auto; font-family: MontserratMedium;font-size: 0.9rem;color: #4a4a4a;text-align: center;line-height: 2rem;}
  .index01 .tabsBox .tabsContent>ul .iconLi .borderDiv.border .textContent{width: 100%;margin: auto;font-family: Montserrat300;font-size: 0.75rem;color: #515151;text-align: center;line-height: 1.2rem;}

  /*板块2*/
  .index02{height: auto;background-color: #f6f6f6;padding: 2rem 0;}
  .index02 .contentBox{width: 100%;height: auto;}
  .index02 .contentBox .text1{width: 90%;font-size: 0.875rem;font-family:Montserrat300; color: #4a4a4a;text-align: center;margin: auto;line-height: 1.5rem;height: auto;}
  .index02 .contentBox .index02Ul{width: 100%;height: auto;margin-top: 3rem;}
  .index02 .contentBox .index02Ul .index02Li{float: left;width: 100%;height: 100%;overflow: hidden;margin-bottom: 3rem;}
  .index02 .contentBox .index02Ul .index02Li:nth-of-type(3){margin-bottom: 0rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi{}
  .index02 .contentBox .index02Ul .index02Li.leftLi .div80{width: 17rem;height: 100%; margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .title{font-size: 1rem;font-family: Montserrat600; color: #4a4a4a;text-align: center;line-height: 2.5rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .content{font-size: 0.875rem;color: #4a4a4a;font-family:Montserrat300;  text-align: center;line-height: 1.5rem;margin-top: 1rem;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv{width: 100%;height:2.5rem;margin-top: 2rem; }
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn1{font-family: MontserratMedium; width: 6.875rem;line-height: 2.5rem;text-align: center;font-size: 0.93rem;float: left;color: #4a4a4a;border: 1px solid #4a4a4a;border-radius: 4px;font-weight: 500;cursor: pointer;}
  .index02 .contentBox .index02Ul .index02Li.leftLi .btnDiv .btn2{font-family: MontserratMedium;width: 6.875rem;line-height: 2.5rem;text-align: center;font-size: 0.93rem;float: right;color: #fff;border: 1px solid #083358;background-color: #083358; border-radius: 4px;font-weight: 500;cursor: pointer;}
  .index02 .contentBox .index02Ul .index02Li.centerLi .div80{background: url("../../../assets/icon/home_index2_yuan.png") no-repeat center center;width: 17rem;height: 17rem;display: flex;align-items: center;background-size: 100% 100%;margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.centerLi .centerText{font-family:Montserrat300;width:100%;height: 3.9rem;align-items: center;text-align: center;font-size: 0.875rem;color: #4a4a4a;line-height: 1.3rem;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .div80{width: 19rem;height: 100%; margin: auto;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .rowBox{font-family:Montserrat300;font-size: 0.875rem;color: #4a4a4a;display: flex;align-items: center;margin-bottom: 2rem;}
  .index02 .contentBox .index02Ul .index02Li.rightLi .rowBox>img{margin-right: 1rem;}

  /*板块3*/
  .index03{height: auto;background-color: #fff;padding: 2rem 0;}
  .index03 .contentBox{width: 90%;height: auto;padding: 0 5%;float: left;}
  .index03 .contentBox>ul{width: 100%;height: auto;}
  .index03 .contentBox>ul>li{float: left;width:calc(50% - 5px);height: 12rem;padding: 0; }
  .index03 .contentBox>ul>li:nth-of-type(even){float: right;}
  .index03 .contentBox>ul>li .iconDiv{width: 100%;height: 6rem;text-align: center;margin-top: 1rem;display: flex;align-items: center;}
  .index03 .contentBox>ul>li .iconDiv>img{align-items: center;margin: auto;}
  .index03 .contentBox>ul>li .textDiv{width: 100%;font-size: 14px;word-wrap:break-word;color: #6d7278;text-align: center;line-height: 1.3rem;font-family: MontserratMedium;}

  /*板块4*/
  .index04{height: auto;background-color: #181818;padding: 4rem 0;}
  .index04 .content_center_title{color: #fff;}
  .index04 .contentBox{width: 80%;margin:2rem auto;color: #fff;font-size: 0.875rem;text-align: center;line-height: 1.5rem;font-family:Montserrat300;}
  .index04 .btn{width: 6.875rem;line-height: 2.5rem;margin: 4rem auto;font-size: 0.875rem;color: rgba(255,255,255,0.6);cursor: pointer; border: 1px solid rgba(255,255,255,0.6);border-radius: 4px;text-align: center;font-family: MontserratMedium;}
  .index04 .btn:hover{color: #fff;border-color: #fff;transition: all 0.5s ease-in-out; }
  .index04 .logoUl{width: 100%;height:auto;}
  .index04 .logoUl>li{width: 100%;height: 5rem;display: flex;align-items: center;}
  .index04 .logoUl>li>img{align-items: center;margin: auto;}


  /*板块5*/
  .index05{height: auto;background-color: #f6f6f6;padding: 45px 0;}
  .index05 .index5Ul{width: 100%;height: auto;}
  .index05 .index5Ul .index5Li{width: 100%;height: 100%;}
  .index05 .index5Ul .index5Li .mapBox{width: 19rem;height: 19rem;border-radius: 50%;display: flex;align-items: center;overflow: hidden;margin: auto;}
  .index05 .index5Ul .index5Li .mapBox>img{align-items: center;margin: auto;}
  .index05 .index5Ul .index5Li .mapTitle{width: 17rem;height: 3rem;line-height: 3rem;margin: auto; font-family:OpenSans600;text-align: center;font-size: 0.875rem;color: #515151;}
  .index05 .index5Ul .index5Li .mapContent{width: 13rem;height: auto; line-height: 1.5rem;margin: auto; font-family:Montserrat300;text-align: center;font-size: 0.875rem;color: #515151;}


  .hideBox{display: none;}

</style>
